<template>
    <div class="date-menu flex" :class="isMobile? 'date-menu-mobile' : ''">
        <div v-if="!isMobile">
            <button v-on:click.stop="openDate('today')" class="btn btn-link btn-menu" v-bind:class="{ active: open === 'today' }">
                {{translate('dates', 'Today', language)}} <span class="badge badge-primary">{{today}}</span>
            </button>
            <button v-on:click.stop="openDate('early')" class="btn btn-link btn-menu" v-bind:class="{ active: open === 'early' }">
                {{translate('dates', 'Early', language)}} <span class="badge badge-primary">{{early}}</span>
            </button>
            <button v-on:click.stop="openDate('live')" class="btn btn-link btn-menu font-extra-bold" v-bind:class="{ active: open === 'live' }">
                {{translate('dates', 'Live', language)}} <span class="badge badge-danger">{{live}}</span>
            </button>
            <button v-on:click.stop="openMixParlay()" class="btn btn-link btn-menu" v-bind:class="{ active: open === 'mixParlay' }">
                {{translate('dates', 'MixParlay', language)}} <span class="badge badge-primary">{{mixParlay}}</span>
            </button>
            <button
                    v-if="focusName !== false && showOnOpenSport === true"
                    v-on:click.stop="openDate('focusedTournament')"
                    class="btn btn-link btn-menu"
                    v-bind:class="{ active: open === 'focusedTournament' }"
            >
                <span class="focused-tournament-color">{{ focusMenuTitle }}</span> <span class="badge badge-success">{{ focusedCount }}</span>
            </button>

        </div>

        <SelectBox :options="selectDates()" @selectChange="selectChange" :is-menu="true" translationType="dates" :currentIndex="selectedIndex()" v-else/>

        <SelectBox
                class="pull-right"
                :options="menuCountries"
                @selectChange="setOddsFormat"
                :currentIndex="oddsFormatIndex"
                :is-menu="false"
                translationType="oddsFormat"
                v-if="translationLoaded"
        />
        <button class="btn btn-link refresh" v-on:click.stop="refreshFeed">
            <font-awesome-icon icon="fa-solid fa-arrow-rotate-right"/>
        </button>
    </div>
</template>

<script>
    import SelectBox from "./SelectBox";
    import { mapGetters } from 'vuex'
    const _ = require('lodash')
    export default {
        name: 'DateMenu',
        components: {SelectBox},
        computed: {
          ...mapGetters({
              today: 'counters/today',
              early: 'counters/early',
              live: 'counters/live',
              mixParlay: 'counters/mixParlay',
              focusedCount: 'counters/focusedCount',
              isSetToMixParlay: 'settings/mixParlay',
              menuCountries: 'settings/oddsFormatList',
              oddsFormatIndex: 'settings/oddsFormatIndex',
              isMobile: 'settings/isMobile',
              language: 'settings/language',
              showLive: 'settings/showLive',
              translationLoaded: 'settings/translationLoaded',
              focusName: 'settings/focusName',
              focusMenuTitle: 'settings/focusMenuTitle',
              showOnOpenSport: 'settings/showOnOpenSport',
          })
        },
        props: {
          open: String
        },
        methods: {
            openDate(date) {
                this.$store.dispatch('settings/setMixParlayFalse')
                this.$emit('openDate',date)
            },
            openMixParlay() {
                this.openDate('mixParlay')
                this.$store.dispatch('settings/setMixParlayTrue')
            },
            refreshFeed() {
                this.$emit('refreshFeed')
            },
            setOddsFormat(newFormat) {
                this.$store.dispatch('settings/setOddsFormat', newFormat)
            },
            selectDates() {
                let dates = {
                    a: {name: 'Today', value: this.today, date: 'today'},
                    b: {name: 'Early', value: this.early, date: 'early'},
                    c: {name: 'Live', value: this.live, date: 'live'},
                    d: {name: 'MixParlay', value: this.mixParlay, date: 'mixParlay'},
                }
                if(this.focusName !== false && this.showOnOpenSport === true) {
                    dates.e = {name: this.focusMenuTitle, value: this.focusedCount, textClass: 'focused-tournament-color', badgeType: 'badge-success', date: 'focusedTournament'}
                }
                return dates
            },
            selectedIndex() {
                let currentIndex
                _.forEach(this.selectDates(), (object, index) => {
                    if(object.date === this.open){
                        currentIndex = index
                    }
                })
                return currentIndex
            },
            selectChange(selectedIndex) {
                let objSelected = _.head(_.filter(this.selectDates(), (obj, index) => selectedIndex === index))
                this.openDate(objSelected.date)
            },
        }
    }
</script>